import HotelOutlined from "@mui/icons-material/HotelOutlined";
import FlightOutlined from "@mui/icons-material/FlightOutlined";
import LocalActivityOutlined from "@mui/icons-material/LocalActivityOutlined";
import InterestsOutlined from "@mui/icons-material/InterestsOutlined";
import RestaurantOutlined from "@mui/icons-material/RestaurantOutlined";
import type { IconGlyph } from "../component/reusableComponent/icon/Icon";
import type { Badge } from "../component/reusableComponent/cards/types";

export const ActivitiesData = [
  "Historical Sights",
  "Nightlife",
  "Unique Foods",
  "Hiking",
  "Festivals",
  "Major / Special Events",
  "Biking",
  "Theme Parks",
  "Beaches",
  "Boating",
  "Fishing",
  "Water Sports",
];

export const FoodPreferData = [
  { id: 1, data: "Vegetarian" },
  { id: 2, data: "Gluten-Free" },
  { id: 3, data: "Coelia" },
  { id: 4, data: "Dairy-free" },
  { id: 5, data: "Lactose-free" },
  { id: 6, data: "Vegan" },
  { id: 7, data: "Paleo" },
  { id: 8, data: "Pescetian" },
  { id: 9, data: "Low FODMAP" },
  { id: 10, data: "Keto" },
  { id: 11, data: "Hala" },
  { id: 12, data: "Kosher" },
  { id: 13, data: "Hindu" },
  { id: 14, data: "Jain" },
  { id: 15, data: "Diabetes" },
];

export const ClimateInfo = [
  { id: 1, data: "Rainforest" },
  { id: 2, data: "Tropical" },
  { id: 3, data: "Mediterranean" },
  { id: 4, data: "Desert" },
  { id: 5, data: "Grassland" },
  { id: 6, data: "Arctic" },
  { id: 7, data: "Mountains" },
  { id: 8, data: "Rivers" },
];

export const PopulationInfo = [
  { id: 1, data: "Big City" },
  { id: 2, data: "Urban" },
  { id: 3, data: "Suburbs" },
  { id: 4, data: "Small City" },
  { id: 5, data: "Village / Hamlet" },
  { id: 6, data: "Rural" },
  { id: 7, data: "Remote" },
];

export const experienceData = [
  { id: 1, data: "Historical Sights" },
  { id: 2, data: "Nightlife" },
  { id: 3, data: "Unique Foods" },
  { id: 4, data: "Hiking" },
  { id: 5, data: "Festivals" },
  { id: 6, data: "Major / Special Events" },
  { id: 7, data: "Biking" },
  { id: 8, data: "Theme Parks" },
  { id: 9, data: "Beaches" },
  { id: 10, data: "Nature" },
  { id: 11, data: "Boating" },
  { id: 12, data: "Fishing" },
  { id: 13, data: "Water Sports" },
];

export const monthsInfo = [
  "Anytime",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

export type MemoryCategory = "stays" | "flights" | "activities" | "general" | "dietary";

export type MemorySource = "user" | "learned";

export type MemoryLogKind = MemorySource | "removed";

export interface MemoryCategoryConfig {
  id: MemoryCategory;
  title: string;
  icon: IconGlyph;
  labels: Record<string, string>;
}

export const MEMORY_VALUE_MAX_LENGTH = 4000;

export const MEMORY_LOG_BADGES: Record<MemoryLogKind, Badge> = {
  learned: { label: "Learned", tone: "info" },
  user: { label: "Set by you", tone: "success" },
  removed: { label: "Removed", tone: "neutral" },
};

export const MEMORY_CATEGORIES: MemoryCategoryConfig[] = [
  {
    id: "stays",
    title: "Stays",
    icon: HotelOutlined,
    labels: {
      hotelAmenities: "Hotel amenities",
      roomAmenities: "Room amenities",
      brands: "Hotel brands",
      starRating: "Hotel star rating",
      guestRating: "Hotel guest rating",
      refundable: "Refundable stays",
      breakfast: "Breakfast preference",
    },
  },
  {
    id: "flights",
    title: "Flights",
    icon: FlightOutlined,
    labels: {
      stops: "Flight stops",
      airlines: "Airlines",
      homeAirport: "Home airport",
      luggage: "Checked baggage",
      cabinBag: "Carry-on baggage",
    },
  },
  {
    id: "activities",
    title: "Activities",
    icon: LocalActivityOutlined,
    labels: {
      cancellationPolicy: "Activity cancellation",
      userRating: "Activity rating",
      languages: "Tour languages",
    },
  },
  {
    id: "general",
    title: "Interests",
    icon: InterestsOutlined,
    labels: {
      museum: "Museums",
      gallery: "Galleries",
      dining: "Dining",
      cafe: "Cafes",
      drinking: "Bars and drinking",
      foodRetail: "Food shops and markets",
      park: "Parks and gardens",
      wellness: "Wellness and spa",
      performance: "Shows and performances",
      landmark: "Landmarks and sights",
      nightlife: "Nightlife",
      outdoorActivity: "Outdoor activities",
      shopping: "Shopping",
      sport: "Sports",
      aesthetic: "Overall aesthetic",
    },
  },
  {
    id: "dietary",
    title: "Dietary",
    icon: RestaurantOutlined,
    labels: {
      freeText: "Dietary needs",
    },
  },
];
